import {Grid, Table, TableCell, TableRow} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import moment from "moment";
import axios from 'axios';

import {CheckboxEditor, FormDialog} from "../../../../controls";
import Validator from "../../validators/SplitFuelOrderValidator";

import {getApiSitePrefix} from "../../../../functions/SiteDefaults";
const apiSitePrefix = getApiSitePrefix();

const SplitFuelOrderDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.SystemData;
  //const formatChars = props.formatChars;

  const queryClient = useQueryClient();
  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    noteUuid: null,
    title: 'Select Flights to move to a New Order',
    order: null
  });

  const OrderLinesSelection = (props) => {
    const {record} = props;
    if (!Array.isArray(record.lines)) return null;
    return (
      <Table>        
        {record.lines.map((line, i) => {
          return (
            <TableRow>
              <TableCell width="50px" style={{padding: 5}}><CheckboxEditor id={`cb_${i}`} value={record.selectedLines[i]} onChange={(value)=>{
                const selectedLines = record.selectedLines;
                selectedLines[i] = value;
                props.changeRecord({...record, selectedLines});
              }}/></TableCell>
              {line.direction === 'OUT'?
                <TableCell style={{padding: 5}}>{line.airlineCode}{line.flightNo} {moment.utc(line.departureDate).format('D MMM')} {line.scheduledDepartureTimeUTC}</TableCell>
              :
                <TableCell style={{padding: 5}}>{line.airlineCode}{line.flightNo} {moment.utc(line.arrivalDate).format('D MMM')} {line.scheduledArrivalTimeUTC}</TableCell>
              }     
            </TableRow>
          )
        })}
      </Table>
    )
  }

  const DisplayForm = () => {

      return (
        <FormDialog
          title={dialogState.title}
          message="Select one or more flights to move to the new order"
          open={dialogState.showDialog}
          record={{fuelOrderUuid: dialogState.order.fuelOrderUuid, lines: dialogState.order?.lines||[], selectedLines: new Array((dialogState.order?.lines||[]).length).fill(false)}}
          dialogOptions={{width: "xs", maxWidth: "xs", fullWidth: true}}
          classes={classes}
          validator={Validator}
          buttons = {{
            save:{icon: "dynamic_feed", key: "Save", label: "Split Order", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }}
          onChange={(state) => {
            if (state.buttonPressed === "save") {
              const {record} = state;
              const linesToMoveToNewOrder = [];
              record.lines.forEach((line, i) => {
                if (record.selectedLines[i]) {
                  linesToMoveToNewOrder.push(line);
                }
              });
              SystemData.confirm(
                `Split Fuel Order`,
                `Are you sure you wish to split the Fuel Order'`,
                [
                  {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
                  {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
                ],
                (response) => {
                  if (response) {
                    axios.put(
                      `${apiSitePrefix}/fuelorder/split`, {...record, linesToMoveToNewOrder}
                    ).then(() => {
                      setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
                      if (props.afterSave) {
                        props.afterSave();
                      }
                    }).catch((err) => {
                      console.error(err);
                      SystemData.openAlert("Error splitting order", "An unexpected error has occurred while splitting the fuel order.");
                    })
                  }
                }
              );
            } else {
              setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
            }
          }}
        >
          <Grid container checkChildren={true} spacing={3}>
            <Grid item xs={12} checkChildren={true}>
              {(record, changeRecord, changeButtonState)=>
                <OrderLinesSelection
                  record={record}
                  changeRecord={changeRecord}
                  changeButtonState={changeButtonState}
                />
              }
            </Grid>
          </Grid>
        </FormDialog>
      )
  }

  useEffect(()=> {
    const open = async (params) => {
      //TODO: tripLegUuid should be primaryObjectUuid as it can be either tripLegUuid or tripUuid
      const {title, canEdit, order} = params;
      setDialogState({...dialogState, showDialog:true, canEdit, title, order});
    }
    eventBus.bind("SplitFuelOrderDialog.open", open);
    return () => {
      eventBus.unbind("SplitFuelOrderDialog.open", open);
    }
  }, [dialogState, eventBus, queryClient]);

  if (dialogState.showDialog) {
    return (
      <DisplayForm />
    )
  }
  return (<></>);
}

export default SplitFuelOrderDialog;
